module.exports = __webpack_public_path__ + "img/silicium-ore.c95eaa2e.png";